import React from "react";
import { connect } from "react-redux";
import DashboardOverview from "../components/Dashboard/Overview";

function DashboardOverviewPage({ accessToken }) {
  return <DashboardOverview accessToken={accessToken} />;
}

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
  };
}

export default connect(mapStateToProps, null)(DashboardOverviewPage);
